import * as React from 'react'
import { Stepper } from '@progress/kendo-react-layout';
import { RadioButton } from '@progress/kendo-react-inputs';
import { Table, Row, Col } from "reactstrap";
import { AccentSpinner } from "../controls/AccentSpinner";
import { JobDiffCtrl } from "../controls/jobs/JobDiffCtrl";
import { AccentRadioUnboundCustom } from "../controls/unbound/AccentRadioUnbound";
import { queryNoTracking, update } from "../services/DataService";
import { format, t, from, accentUtils, showWait } from "../services/HelperService";
import { Helper, finishEditMatchPriceModes } from "../services/JobService";
import { getAccess, getUser } from "../services/UserService";
import { AccentDialog } from './AccentDialog';
import { AccentButton } from '../controls/AccentButton';
import { showJobChangesSummaryReport } from '../controls/jobs/JobChangesSummaryReportDlg';


const jobEditPriceAction = {
    Quote: 1,
    CurrentQuote: 2,
    BeforeEdit: 3,
    NewPrice: 4,
    CurrentBeforeEdit: 5
};

const unconfirmedStages = ["stage_job_line_unconfirmed", "stage_job_line_unconfirmed_sent"];

const keepPriceLineTypes = {
    New: "new",
    AutoKept: "auto",
    Decision: "decision",
    Removed: "removed"
};

// Presentation tuning for the keep price decision grid.
const keepPriceFlatGridMax = 8;
const keepPriceMinGroupSize = 3;

const keepPriceStrings = "application_strings.application.dialogs.finishEditJob";


export class FinishEditJobDlg extends React.Component {

    constructor(props) {
        super(props);

        
        this.jobID = props.jobID;
        this.editModel = props.editModel;
        this.quoted = this.editModel.QuoteInfo;
        this.userModel = props.userModel;

        this.allowPriceOverride = getAccess().features().FeatureAllowFinishEditPriceOverride();
        this.keepPriceMode = this.editModel.FinishEditPriceMode === finishEditMatchPriceModes.KeepLinePricesLockByThreshold;

        const enabledPriceActions = this.getEnabledPriceActions();
        const initialPriceActionType = enabledPriceActions.length === 1 ? enabledPriceActions[0] : null;

        const initialKeepDecisions = this.keepPriceMode ? this.getInitialKeepPriceDecisions() : null;

        this.state = {
            step: 0,
            allowMoveToReview: this.keepPriceMode
                ? this.keepPriceDecisionsComplete(initialKeepDecisions)
                : initialPriceActionType !== null,
            allowMoveToWarnings: false,
            keepDecisions: initialKeepDecisions,
            useJobPriceActions: false,
            showAutoKept: false,
            showMarginCols: false
        };
        this.model = {
            priceActionType: initialPriceActionType
        };

        this.skipPriceActionPage = (this.editModel.Diff.NewSalePrice - this.editModel.Diff.OriginalSalePrice) === 0;


        this.loadingPriceInfo = false;
        this.priceUpdateRequired = false;
        this.priceSetToAction = jobEditPriceAction.NewPrice;
        this.getPriceAmountFor = this.getPriceAmountFor.bind(this);
        this.updatePrice = this.updatePrice.bind(this);
        this.onPriceActionChanged = this.onPriceActionChanged.bind(this);
        this.getConflictTable = this.getConflictTable.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.componentDidUpdate = this.componentDidUpdate.bind(this);
        this.onStepChanged = this.onStepChanged.bind(this);
        this.getPricingContent = this.getPricingContent.bind(this);
        this.getReviewContent = this.getReviewContent.bind(this);
        this.getWarningsContent = this.getWarningsContent.bind(this);
        this.getVisiblePriceActions = this.getVisiblePriceActions.bind(this);
        this.getEnabledPriceActions = this.getEnabledPriceActions.bind(this);
        this.canSelectPriceAction = this.canSelectPriceAction.bind(this);
        this.getKeepPriceEligibleLines = this.getKeepPriceEligibleLines.bind(this);
        this.classifyKeepPriceLine = this.classifyKeepPriceLine.bind(this);
        this.getInitialKeepPriceDecisions = this.getInitialKeepPriceDecisions.bind(this);
        this.keepPriceDecisionsComplete = this.keepPriceDecisionsComplete.bind(this);
        this.onKeepDecisionChanged = this.onKeepDecisionChanged.bind(this);
        this.onKeepDecisionBulk = this.onKeepDecisionBulk.bind(this);
        this.onToggleJobPriceActions = this.onToggleJobPriceActions.bind(this);
        this.getKeepPricePricingContent = this.getKeepPricePricingContent.bind(this);
        this.getKeepPriceRow = this.getKeepPriceRow.bind(this);
    }

    componentDidMount() {

    }

    componentDidUpdate() {
       

    }



    onStepChanged(e) {

        const me = this;

        console.log(`onStepChanged START:: ${e.value}`);

        if (e.value === 1 && this.state.step === 0) {
            this.setState({ step: e.value, priceLoading: true }, () => {
                this.updatePrice();
            });
        }else if (e.value === 0 && this.state.step !== 0) {
                this.setState({ step: e.value, priceLoading: true }, () => {
                    update("EditJobBackToPricePrice", {
                        ID: this.jobID
                    }).then(function (res) {
                        me.priceSetToAction = me.model.priceActionType;

                        me.editModel = res;
                        me.setState({ priceLoading: false });

                    });
                });
        } else if (e.value === 3) {

            const done = showWait();

            Helper.completeEditJobWizard(this.jobID).then(function (res) {
                done();
                me.props.onClose({ canceled: false });                                
            });

        } else {
            this.setState({ step: e.value });
        }

        

        if (e.promise) e.promise();

    }

    getPriceAmountFor(selectedType) {

        if (selectedType === jobEditPriceAction.BeforeEdit) {
            return this.editModel.Diff.OriginalSalePrice;
        } else if (selectedType === jobEditPriceAction.CurrentQuote) {
            return this.editModel.QuoteInfo.FilteredSalesPriceInc;
        } else if (selectedType === jobEditPriceAction.Quote) {
            return this.quoted.SalesPriceInc;
        } else if (selectedType === jobEditPriceAction.CurrentBeforeEdit) {
            return this.editModel.Diff.FilteredOriginalSalePrice;
        } else if (selectedType === jobEditPriceAction.NewPrice) {
            return this.editModel.Diff.NewSalePrice;
        }

        return 0;
    }

    getVisiblePriceActions() {
        const showQuote = this.quoted.SalesPriceInc !== this.editModel.Diff.OriginalSalePrice;
        const showCurrentQuote = this.quoted.SalesPriceInc !== this.quoted.FilteredSalesPriceInc;
        const showCurrentOriginal = this.editModel.Diff.FilteredOriginalSalePrice !== this.editModel.Diff.OriginalSalePrice;

        return [
            ...(showQuote ? [jobEditPriceAction.BeforeEdit] : []),
            ...(showCurrentOriginal ? [jobEditPriceAction.CurrentBeforeEdit] : []),
            jobEditPriceAction.Quote,
            ...(showCurrentQuote ? [jobEditPriceAction.CurrentQuote] : []),
            jobEditPriceAction.NewPrice
        ];
    }

    getEnabledPriceActions() {
        const visibleActions = this.getVisiblePriceActions();

        if (getAccess().features().FeatureAllowFinishEditPriceOverride()) {
            return visibleActions;
        }

        return visibleActions.filter(a => a === jobEditPriceAction.NewPrice);
    }

    canSelectPriceAction(action) {
        return this.getEnabledPriceActions().includes(action);
    }

    getKeepPriceEligibleLines() {
        return from(this.editModel.Diff.Lines)
            .where(l => !unconfirmedStages.includes(l.Stage))
            .toArray();
    }

    // Price the line gets when repriced freely (pins/manual discounts removed, promotions re-evaluated).
    // Falls back to the current sale price for older server payloads.
    getKeepPriceNewPrice(line) {
        return line.UnlockedSalePrice ?? line.SalePriceInc;
    }

    // Manual (rep) discount that "use new price" drops. Keeping the price keeps it.
    // Only a genuine discount (positive) is a rep discount; a zero / negative or sub cent amount is a
    // pricing artefact (rounding, frozen rule not matching) and must never be shown as one.
    getKeepPriceDroppedManualDiscount(line) {
        const amount = line.ManualDiscountIncTax ?? 0;
        return amount > 0.005 ? amount : 0;
    }

    getKeepPriceNewMargin(line) {
        const newPrice = this.getKeepPriceNewPrice(line);
        return newPrice === 0 ? 0 : (newPrice - (line.NewCost ?? 0)) / newPrice;
    }

    classifyKeepPriceLine(line) {

        if (line.IsNewLine || accentUtils.isNull(line.BeforeEditSalePrice)) return keepPriceLineTypes.New;

        // The threshold decision is made server side (JobLineDiff.AutoKeep).
        return line.AutoKeep ? keepPriceLineTypes.AutoKept : keepPriceLineTypes.Decision;
    }

    getInitialKeepPriceDecisions() {

        const res = {};

        this.getKeepPriceEligibleLines().forEach(l => {
            const type = this.classifyKeepPriceLine(l);

            if (type === keepPriceLineTypes.AutoKept) {
                res[l.ID] = true;
            } else if (type === keepPriceLineTypes.New) {
                res[l.ID] = false;
            } else {
                res[l.ID] = this.allowPriceOverride ? null : false;
            }
        });

        return res;
    }

    keepPriceDecisionsComplete(decisions) {
        return this.getKeepPriceEligibleLines().every(l => decisions[l.ID] === true || decisions[l.ID] === false);
    }

    onKeepDecisionChanged(lineID, keep) {

        if (!this.allowPriceOverride) return;

        const keepDecisions = { ...this.state.keepDecisions, [lineID]: keep };

        this.setState({ keepDecisions, allowMoveToReview: this.keepPriceDecisionsComplete(keepDecisions) });
    }

    onKeepDecisionBulk(lineIDs, keep) {

        if (!this.allowPriceOverride) return;

        const keepDecisions = { ...this.state.keepDecisions };
        lineIDs.forEach(id => { keepDecisions[id] = keep; });

        this.setState({ keepDecisions, allowMoveToReview: this.keepPriceDecisionsComplete(keepDecisions) });
    }

    onToggleJobPriceActions(useJobPriceActions) {

        this.setState({
            useJobPriceActions,
            allowMoveToReview: useJobPriceActions
                ? this.model.priceActionType !== null
                : this.keepPriceDecisionsComplete(this.state.keepDecisions)
        });
    }

    updatePrice() {

        var me = this;

        if (this.keepPriceMode && !this.state.useJobPriceActions) {

            const eligibleLines = this.getKeepPriceEligibleLines();
            const keptIDs = eligibleLines.filter(l => this.state.keepDecisions[l.ID] === true).map(l => l.ID);
            const resultingTotal = eligibleLines.reduce((sum, l) => sum + (this.state.keepDecisions[l.ID] === true ? l.BeforeEditSalePrice : this.getKeepPriceNewPrice(l)), 0);

            // Always send KeepPriceLineIDs (even empty): lines not listed must be unpinned
            // and repriced, so the price update cannot be skipped.
            update("FinishEditJobSetPrice", {
                ID: this.jobID,
                SalePriceIncTax: resultingTotal,
                LeavePriceUnchanged: false,
                Lines: eligibleLines.map(l => l.ID),
                MatchPriceSnapshotType: null,
                KeepPriceLineIDs: keptIDs
            }).then(function (res) {
                me.priceSetToAction = me.model.priceActionType;

                me.editModel = res;
                me.setState({ priceLoading: false, allowMoveToWarnings: true });
            });

            return;
        }

        var newSalePrice = this.getPriceAmountFor(this.model.priceActionType);


        var lines = from(this.editModel.Diff.Lines).where(l => l.Stage !== "stage_job_line_unconfirmed" && l.Stage !== "stage_job_line_unconfirmed_sent")
            .select(l => l.ID)
            .toArray();


        const currentPrice = this.getPriceAmountFor(jobEditPriceAction.NewPrice);
        const matchPriceSnapshotType = this.model.priceActionType === jobEditPriceAction.Quote || this.model.priceActionType === jobEditPriceAction.CurrentQuote
            ? "Quote"
            : this.model.priceActionType === jobEditPriceAction.BeforeEdit || this.model.priceActionType === jobEditPriceAction.CurrentBeforeEdit
                ? "Edit"
                : null;


        update("FinishEditJobSetPrice", {
            ID: this.jobID,
            SalePriceIncTax: newSalePrice,
            LeavePriceUnchanged: !matchPriceSnapshotType && currentPrice === newSalePrice,
            Lines: lines,
            MatchPriceSnapshotType: matchPriceSnapshotType
        }).then(function (res) {
            me.priceSetToAction = me.model.priceActionType;

            me.editModel = res;
            me.setState({ priceLoading: false, allowMoveToWarnings : true });

        });




    }

    onPriceActionChanged(action) {
        if (!this.canSelectPriceAction(action)) return;

        this.model.priceActionType = action;

        this.setState({ allowMoveToReview: true });
    }

    onCancel() {
        var me = this;

        return new Promise(function (p) {

            Helper.cancelEditJobWizard(me.editModel).then(function (res) {
                p(me.jobID);
            });

        });
    }



    getConflictTable() {
        var rows = this.editModel.Conflicts.map(function (c) {
            return <tr key={c.Type + c.ID}>
                <td>{t(c.Type)}</td>
                <td>{format.formatDate(c.Date)}</td>
                <td>{c.Description}</td>
                <td className="acc-diff-sugg">{t(c.Type + "_suggestion")}</td>
            </tr>;
        });


        rows.unshift(<tr key={"job" + this.editModel.ID}>
            <td>{t("job_edit_conflict_order")}</td>
            <td>{format.formatDate(this.editModel.JobDate)}</td>
            <td>{this.editModel.Reference}</td>
            <td className="acc-diff-sugg">{t("job_edit_conflict_order_suggestion")}</td>
        </tr>);

        return <Table className="table-sm">
            <tbody>
                {rows}
            </tbody >
        </Table>;

    }


    getKeepPriceRow(entry, decisions, userAllowCost) {

        const line = entry.line;
        const isNew = entry.type === keepPriceLineTypes.New;
        const isRemoved = entry.type === keepPriceLineTypes.Removed;
        const decision = decisions[line.ID];
        const isPendingDecision = entry.type === keepPriceLineTypes.Decision && decision !== true && decision !== false;
        const showMargins = userAllowCost && this.state.showMarginCols;

        // Removed line diffs are built from the edit snapshot only, so their before edit
        // values sit in SalePriceInc/Margin rather than the BeforeEdit* fields.
        const beforePrice = isRemoved ? line.SalePriceInc : line.BeforeEditSalePrice;
        const beforeMargin = (isRemoved ? line.Margin : line.BeforeEditMargin) ?? 0;
        const keptMargin = line.MarginIfPriceKept ?? 0;
        const newPrice = isRemoved ? null : this.getKeepPriceNewPrice(line);
        const newMargin = isRemoved ? 0 : this.getKeepPriceNewMargin(line);

        // Change column reflects the selection: keeping the price changes nothing, repricing
        // moves it by new - before. While undecided it shows the potential reprice change.
        // New and removed lines always contribute their full price.
        const priceVar = isRemoved ? -(beforePrice ?? 0)
            : isNew ? newPrice
                : decision === true ? 0
                    : newPrice - (beforePrice ?? 0);

        // Price going up is bad (breaks the honoured price), down is good; margin is the opposite.
        // Unchanged values stay uncoloured.
        const priceVarClass = priceVar > 0.005 ? "diff-warn" : priceVar < -0.005 ? "diff-ok" : "";
        const marginClass = (m, baseline) => isNew || isRemoved ? "" : m - baseline < -0.0001 ? "diff-warn" : m - baseline > 0.0001 ? "diff-ok" : "";

        // Kept margin answers "how has keeping the price moved my margin since the edit?";
        // new margin answers "what do I give up (or gain) by repricing instead of keeping?".
        const keptMarginClass = marginClass(keptMargin, beforeMargin);
        const newMarginClass = marginClass(newMargin, keptMargin);

        // De-emphasise the price the user decided against.
        const beforePriceClass = decision === false ? " text-muted" : "";
        const newPriceClass = decision === true ? " text-muted" : "";

        // The new price is the system price: a rep discount on the line does not carry over to it.
        const droppedManualDiscount = isRemoved || isNew ? 0 : this.getKeepPriceDroppedManualDiscount(line);
        const droppedManualDiscountNote = droppedManualDiscount === 0 ? null :
            <div className="small text-muted" title={t(`${keepPriceStrings}.keepPriceManualDiscountDroppedTitle`)}>
                {t(`${keepPriceStrings}.keepPriceManualDiscountDropped`, { amount: format.formatCurrency(droppedManualDiscount, true) })}
            </div>;

        return <tr key={`${entry.type}_${line.ID}`}>
            <td>{line.LineNo}</td>
            <td>{line.Product}{accentUtils.isEmpty(line.Location) ? "" : ` (${line.Location})`}</td>
            <td className={"accentNumCol" + beforePriceClass}>{isNew ? "" : format.formatCurrency(beforePrice, true)}</td>
            <td className={"accentNumCol" + newPriceClass}>{isRemoved ? "" : format.formatCurrency(newPrice, true)}{droppedManualDiscountNote}</td>
            <td className={"accentNumCol " + priceVarClass}>
                {format.formatCurrency(priceVar, true)}
                <span className={priceVarClass === "diff-warn" ? "accentUp diff-warn" : priceVarClass === "diff-ok" ? "accentDown diff-ok" : undefined} />
            </td>
            {showMargins ? <td className="accentNumCol">{isNew ? "" : format.formatPercentage(beforeMargin, true)}</td> : null}
            {showMargins ? <td className={"accentNumCol " + keptMarginClass}>{isNew || isRemoved ? "" : format.formatPercentage(keptMargin, true)}</td> : null}
            {showMargins ? <td className={"accentNumCol " + newMarginClass}>{isRemoved ? "" : format.formatPercentage(newMargin, true)}</td> : null}
            <td className={isPendingDecision ? "table-warning" : undefined}>
                {isRemoved
                    ? <span className="badge bg-danger">{t(`${keepPriceStrings}.keepPriceRemovedLine`)}</span>
                    : isNew
                        ? <span className="badge bg-success">{t(`${keepPriceStrings}.keepPriceNewLine`)}</span>
                        : <div className="d-flex gap-3">
                            <RadioButton
                                name={`keepPrice_${line.ID}`}
                                checked={decision === true}
                                disabled={!this.allowPriceOverride}
                                label={t(`${keepPriceStrings}.keepPriceKeep`)}
                                onChange={() => this.onKeepDecisionChanged(line.ID, true)} />
                            <RadioButton
                                name={`keepPrice_${line.ID}`}
                                checked={decision === false}
                                disabled={!this.allowPriceOverride}
                                label={t(`${keepPriceStrings}.keepPriceUseNew`)}
                                onChange={() => this.onKeepDecisionChanged(line.ID, false)} />
                        </div>}
            </td>
        </tr>;
    }

    getKeepPricePricingContent() {

        if (this.state.priceLoading) {
            return <div className="text-center"><label>{t(`${keepPriceStrings}.updatingPrice`)}</label><AccentSpinner /></div>;
        }

        const userAllowCost = getAccess().features().FeatureAllowViewCostPrice();
        const showMargins = userAllowCost && this.state.showMarginCols;
        const decisions = this.state.keepDecisions;

        const entries = this.getKeepPriceEligibleLines().map(l => ({ line: l, type: this.classifyKeepPriceLine(l) }));

        const decisionEntries = entries.filter(e => e.type !== keepPriceLineTypes.AutoKept);
        const autoEntries = entries.filter(e => e.type === keepPriceLineTypes.AutoKept);

        // Removed lines render as display only rows (like new lines): nothing to decide,
        // but their dropped value should be visible in the same grid.
        const removedEntries = (this.editModel.Diff.RemovedLines ?? []).map(l => ({ line: l, type: keepPriceLineTypes.Removed }));

        const resultingTotal = entries.reduce((s, e) => s + (decisions[e.line.ID] === true ? e.line.BeforeEditSalePrice : this.getKeepPriceNewPrice(e.line)), 0);
        const resultingCost = entries.reduce((s, e) => s + (e.line.NewCost ?? 0), 0);
        const resultingMargin = resultingTotal === 0 ? 0 : (resultingTotal - resultingCost) / resultingTotal;

        const totalVar = resultingTotal - this.editModel.Diff.OriginalSalePrice;
        const marginVar = resultingMargin - this.editModel.Diff.OriginalMargin;
        const totalVarClass = totalVar > 0.005 ? "diff-warn" : totalVar < -0.005 ? "diff-ok" : "";
        const marginVarClass = marginVar < -0.0001 ? "diff-warn" : marginVar > 0.0001 ? "diff-ok" : "";

        const colCount = showMargins ? 9 : 6;

        const gridHeader = <thead>
            <tr>
                <th>{t(`${keepPriceStrings}.keepPriceColLine`)}</th>
                <th>{t(`${keepPriceStrings}.keepPriceColProduct`)}</th>
                <th className="accentNumCol">{t(`${keepPriceStrings}.keepPriceColBeforePrice`)}</th>
                <th className="accentNumCol">{t(`${keepPriceStrings}.keepPriceColNewPrice`)}</th>
                <th className="accentNumCol">{t(`${keepPriceStrings}.keepPriceColPriceDiff`)}</th>
                {showMargins ? <th className="accentNumCol">{t(`${keepPriceStrings}.keepPriceColBeforeMargin`)}</th> : null}
                {showMargins ? <th className="accentNumCol">{t(`${keepPriceStrings}.keepPriceColKeptMargin`)}</th> : null}
                {showMargins ? <th className="accentNumCol">{t(`${keepPriceStrings}.keepPriceColNewMargin`)}</th> : null}
                <th>{t(`${keepPriceStrings}.keepPriceColDecision`)}</th>
            </tr>
        </thead>;

        const marginToggle = !userAllowCost ? null : <div className="text-end">
            <a href="#" onClick={e => { e.preventDefault(); this.setState({ showMarginCols: !this.state.showMarginCols }); }}>
                {t(`${keepPriceStrings}.${this.state.showMarginCols ? "keepPriceHideMargins" : "keepPriceShowMargins"}`)}
            </a>
        </div>;

        const bulkButtons = (lineIDs, keySuffix) => !this.allowPriceOverride ? null :
            <span className="d-inline-flex gap-2 ms-3 align-middle">
                <AccentButton key={`keepAll_${keySuffix}`} size="sm" tagName={`keepAllBtn_${keySuffix}`} onClick={() => this.onKeepDecisionBulk(lineIDs, true)}>{t(`${keepPriceStrings}.keepPriceKeepAll`)}</AccentButton>
                <AccentButton key={`useNewAll_${keySuffix}`} size="sm" tagName={`useNewAllBtn_${keySuffix}`} onClick={() => this.onKeepDecisionBulk(lineIDs, false)}>{t(`${keepPriceStrings}.keepPriceUseNewAll`)}</AccentButton>
            </span>;

        // Only lines with a before edit price can be bulk kept.
        const keepableIDs = entries => entries.filter(e => e.type === keepPriceLineTypes.Decision).map(e => e.line.ID);

        // Removed lines sit at the end of the decision grid: they need awareness, not action.
        const removedRows = removedEntries.map(e => this.getKeepPriceRow(e, decisions, userAllowCost));

        let decisionSection = null;

        if (decisionEntries.length === 0) {
            decisionSection = <React.Fragment>
                <div className="alert alert-success" role="alert">
                    {autoEntries.length > 0
                        ? t(`${keepPriceStrings}.keepPriceAllKeptInfo`, { count: autoEntries.length })
                        : t(`${keepPriceStrings}.keepPriceNoLinesInfo`)}
                </div>
                {removedRows.length === 0 ? null :
                    <Table className="table-sm">
                        {gridHeader}
                        <tbody>{removedRows}</tbody>
                    </Table>}
            </React.Fragment>;
        } else {

            let rows;

            if (decisionEntries.length <= keepPriceFlatGridMax) {
                rows = decisionEntries.map(e => this.getKeepPriceRow(e, decisions, userAllowCost));
            } else {

                // Group large decision lists by product. Small clusters stay flat at the end.
                const groups = from(decisionEntries).groupBy(e => e.line.Product ?? "").toArray().map(g => ({ key: g.key(), entries: g.toArray() }));
                const largeGroups = groups.filter(g => g.entries.length >= keepPriceMinGroupSize);
                const smallGroupEntries = groups.filter(g => g.entries.length < keepPriceMinGroupSize).flatMap(g => g.entries);

                rows = largeGroups.flatMap(g => [
                    <tr key={`grp_${g.key}`} className="table-active">
                        <td colSpan={colCount}>
                            <strong>{g.key}</strong> ({g.entries.length})
                            {bulkButtons(keepableIDs(g.entries), `grp_${g.key}`)}
                        </td>
                    </tr>,
                    ...g.entries.map(e => this.getKeepPriceRow(e, decisions, userAllowCost))
                ]);

                rows = rows.concat(smallGroupEntries.map(e => this.getKeepPriceRow(e, decisions, userAllowCost)));
            }

            rows = rows.concat(removedRows);

            decisionSection = <React.Fragment>
                <div className="alert alert-info" role="alert">
                    {t(`${keepPriceStrings}.keepPriceDecisionInfo`)}
                </div>
                {decisionEntries.length > 1 && this.allowPriceOverride
                    ? <div className="d-flex justify-content-end mb-2">{bulkButtons(keepableIDs(decisionEntries), "all")}</div>
                    : null}
                <Table className="table-sm">
                    {gridHeader}
                    <tbody>{rows}</tbody>
                </Table>
            </React.Fragment>;
        }

        const autoKeptSection = autoEntries.length === 0 ? null : <div>
            <a href="#" onClick={e => { e.preventDefault(); this.setState({ showAutoKept: !this.state.showAutoKept }); }}>
                {t(`${keepPriceStrings}.${this.state.showAutoKept ? "keepPriceHideAutoKept" : "keepPriceShowAutoKept"}`, { count: autoEntries.length })}
            </a>
            {!this.state.showAutoKept ? null :
                <Table className="table-sm">
                    {gridHeader}
                    <tbody>{autoEntries.map(e => this.getKeepPriceRow(e, decisions, userAllowCost))}</tbody>
                </Table>}
        </div>;

        const totalsSection = <Table className="table-sm table-borderless" style={{ maxWidth: "500px" }}>
            <tbody>
                <tr>
                    <td>{t(`${keepPriceStrings}.keepPriceResultingTotal`)}</td>
                    <td className="accentNumCol">{format.formatCurrency(resultingTotal, true)}</td>
                    <td className={"accentNumCol " + totalVarClass}>{format.formatCurrency(totalVar, true)}<span className={(totalVarClass === "" ? undefined : (totalVar > 0 ? "accentUp " : "accentDown ") + totalVarClass)} /></td>
                </tr>
                {!userAllowCost ? null :
                    <tr>
                        <td>{t(`${keepPriceStrings}.keepPriceResultingMargin`)}</td>
                        <td className="accentNumCol">{format.formatPercentage(resultingMargin, true)}</td>
                        <td className={"accentNumCol " + marginVarClass}>{format.formatPercentage(marginVar, true)}<span className={(marginVarClass === "" ? undefined : (marginVar > 0 ? "accentUp " : "accentDown ") + marginVarClass)} /></td>
                    </tr>}
            </tbody>
        </Table>;

        const jobPriceActionsLink = !this.allowPriceOverride ? null : <div className="mt-2">
            <a href="#" onClick={e => { e.preventDefault(); this.onToggleJobPriceActions(true); }}>{t(`${keepPriceStrings}.keepPriceUseJobActions`)}</a>
        </div>;

        return <div style={{ width: "100%", maxWidth: "1500px" }}>
            {marginToggle}
            {decisionSection}
            {autoKeptSection}
            <hr />
            {totalsSection}
            {jobPriceActionsLink}
        </div>;
    }

    getPricingContent() {

        if (this.keepPriceMode && !this.state.useJobPriceActions) {
            return this.getKeepPricePricingContent();
        }

        if (this.state.priceLoading) {
            return <div className="text-center"><label>{t("application_strings.application.dialogs.finishEditJob.updatingPrice")}</label><AccentSpinner /></div>;
        }

        const userAllowCost = getAccess().features().FeatureAllowViewCostPrice();

        const me = this;
        const showQuote = this.quoted.SalesPriceInc !== this.editModel.Diff.OriginalSalePrice;
        var showCurrentQuote = this.quoted.SalesPriceInc !== this.quoted.FilteredSalesPriceInc;
        var showCurrentOriginal = this.editModel.Diff.FilteredOriginalSalePrice !== this.editModel.Diff.OriginalSalePrice;



        var marginForQuote = accentUtils.calculateMargin(this.quoted.SalesPriceInc, this.editModel.Diff.NewCost);
        var marginForCurrentQuote = accentUtils.calculateMargin(this.quoted.FilteredSalesPriceInc, this.editModel.Diff.NewCost);
        var marginForCurrentOriginal = accentUtils.calculateMargin(this.editModel.Diff.FilteredOriginalSalePrice, this.editModel.Diff.NewCost);

        var quoteVar = this.quoted.SalesPriceInc - this.editModel.Diff.OriginalSalePrice;
        var quoteMarginVar = marginForQuote - this.editModel.Diff.OriginalMargin;
        var currQuoteVar = this.quoted.FilteredSalesPriceInc - this.editModel.Diff.OriginalSalePrice;
        var currQuoteMarginVar = marginForCurrentQuote - this.editModel.Diff.OriginalMargin;
        var currPriceVar = this.editModel.Diff.NewSalePrice - this.editModel.Diff.OriginalSalePrice;
        var currPriceMarginVar = this.editModel.Diff.NewMargin - this.editModel.Diff.OriginalMargin;
        var currOriginalVar = this.editModel.Diff.FilteredOriginalSalePrice - this.editModel.Diff.OriginalSalePrice;
        var currOriginalMarginVar = marginForCurrentOriginal - this.editModel.Diff.OriginalMargin;


        var quoteVarClass = (quoteVar > 0) ? "diff-warn" : "diff-ok";
        var currQuoteVarClass = (currQuoteVar > 0) ? "diff-warn" : "diff-ok";
        var currPriceVarClass = (currPriceVar > 0) ? "diff-warn" : "diff-ok";


        var quoteMarginVarClass = (quoteMarginVar < 0) ? "diff-warn" : "diff-ok";
        var currQuoteMarginVarClass = (currQuoteMarginVar < 0) ? "diff-warn" : "diff-ok";
        var currPriceMarginVarClass = (currPriceMarginVar < 0) ? "diff-warn" : "diff-ok";
        var currOriginalPriceMarginVarClass = (currOriginalMarginVar < 0) ? "diff-warn" : "diff-ok";


        const currOriginalPriceVarClass = (currOriginalVar > 0) ? "diff-warn" : "diff-ok";
        return <div style={{ maxWidth: "700px" }} >            
            <Table className="table-sm table-borderless" >
                <thead>
                    <tr>
                        <th></th>
                        <th colSpan="2">{t("application_strings.application.dialogs.finishEditJob.salePriceInc")}</th>
                        <th colSpan="2">{t("application_strings.application.dialogs.finishEditJob.margin")}</th>
                    </tr>

                </thead>
                <tbody>
                    {!showQuote ? null :
                        <tr>
                            <td><AccentRadioUnboundCustom label="application_strings.application.dialogs.finishEditJob.matchPriceBeforeEdit" checked={me.model.priceActionType === jobEditPriceAction.BeforeEdit} disabled={!me.canSelectPriceAction(jobEditPriceAction.BeforeEdit)} name="priceAction" id="matchBeforeEdit" onChange={function () { me.onPriceActionChanged(jobEditPriceAction.BeforeEdit); }} /></td>
                            <td className="accentNumCol">{format.formatCurrency(this.editModel.Diff.OriginalSalePrice, true)}</td>
                            <td className="accentNumCol"></td>
                            <td className="accentNumCol">{userAllowCost ? format.formatPercentage(this.editModel.Diff.OriginalMargin, true) : ""}</td>
                            <td className="accentNumCol"></td>
                        </tr>
                    }
                    {!showCurrentOriginal ? null :
                        <tr>
                            <td><AccentRadioUnboundCustom label="application_strings.application.dialogs.finishEditJob.matchCurrentPriceBeforeEdit" checked={me.model.priceActionType === jobEditPriceAction.CurrentBeforeEdit} disabled={!me.canSelectPriceAction(jobEditPriceAction.CurrentBeforeEdit)} name="priceAction" id="matchCurrentBeforeEdit" onChange={function () { me.onPriceActionChanged(jobEditPriceAction.CurrentBeforeEdit); }} /></td>
                            <td className="accentNumCol">{format.formatCurrency(this.editModel.Diff.FilteredOriginalSalePrice, true)}</td>
                            <td className={"accentNumCol " + currOriginalPriceVarClass}>{format.formatCurrency(currOriginalVar, true)}<span className={(currOriginalVar > 0 ? "accentUp" + currOriginalPriceVarClass : currOriginalVar < 0 ? "accentDown " + currOriginalPriceVarClass : undefined)} /></td>
                            <td className="accentNumCol">{userAllowCost ? format.formatPercentage(marginForCurrentOriginal, true) : ""}</td>
                            <td className={"accentNumCol " + currOriginalPriceMarginVarClass}>{userAllowCost ? format.formatPercentage(currOriginalMarginVar, true) : ""}<span className={(currOriginalMarginVar > 0 ? "accentUp " + currOriginalPriceMarginVarClass : currOriginalMarginVar < 0 ? "accentDown " + currOriginalPriceMarginVarClass : undefined)} /></td>
                        </tr>
                    }
                    <tr>
                        <td><AccentRadioUnboundCustom label="application_strings.application.dialogs.finishEditJob.matchOriginalQuotePrice" checked={me.model.priceActionType === jobEditPriceAction.Quote} disabled={!me.canSelectPriceAction(jobEditPriceAction.Quote)} name="priceAction" id="matchQuote" onChange={function () { me.onPriceActionChanged(jobEditPriceAction.Quote); }} /></td>
                        <td className="accentNumCol">{format.formatCurrency(this.quoted.SalesPriceInc, true)}</td>
                        <td className={"accentNumCol " + quoteVarClass}>{format.formatCurrency(quoteVar, true)}<span className={(quoteVar > 0 ? "accentUp" + quoteVarClass : quoteVar < 0 ? "accentDown " + quoteVarClass : undefined)} /></td>
                        <td className="accentNumCol">{userAllowCost ? format.formatPercentage(marginForQuote, true) : ""}</td>
                        <td className={"accentNumCol " + quoteMarginVarClass}>{userAllowCost ? format.formatPercentage(quoteMarginVar, true) : ""}<span className={(quoteMarginVar > 0 ? "accentUp " + quoteMarginVarClass : quoteMarginVar < 0 ? "accentDown " + quoteMarginVarClass : undefined)} /></td>
                    </tr>
                    {!showCurrentQuote ? null :
                        <tr>
                            <td><AccentRadioUnboundCustom label={t("application_strings.application.dialogs.finishEditJob.matchCurrentQuotePrice")} checked={me.model.priceActionType === jobEditPriceAction.CurrentQuote} disabled={!me.canSelectPriceAction(jobEditPriceAction.CurrentQuote)} name="priceAction" id="matchQuoteCurrent" onChange={function () { me.onPriceActionChanged(jobEditPriceAction.CurrentQuote); }} /></td>
                            <td className="accentNumCol">{format.formatCurrency(this.quoted.FilteredSalesPriceInc, true)}</td>
                            <td className={"accentNumCol " + currQuoteVarClass}>{format.formatCurrency(currQuoteVar, true)}<span className={(currQuoteVar > 0 ? "accentUp " + currQuoteVarClass : currQuoteVar < 0 ? "accentDown " + currQuoteVarClass : undefined)} /></td>
                            <td className="accentNumCol">{userAllowCost ? format.formatPercentage(marginForCurrentQuote, true) : ""}</td>
                            <td className={"accentNumCol " + currQuoteMarginVarClass}>{userAllowCost ? format.formatPercentage(currQuoteMarginVar, true) : ""}<span className={(currQuoteMarginVar > 0 ? "accentUp " + currQuoteMarginVarClass : currQuoteMarginVar < 0 ? "accentDown " + currQuoteMarginVarClass : undefined)} /></td>
                        </tr>
                    }
                    <tr>
                        <td><AccentRadioUnboundCustom label="application_strings.application.dialogs.finishEditJob.useNewPrice" checked={me.model.priceActionType === jobEditPriceAction.NewPrice} disabled={!me.canSelectPriceAction(jobEditPriceAction.NewPrice)} name="priceAction" id="keepNewPrice" onChange={function () { me.onPriceActionChanged(jobEditPriceAction.NewPrice); }} /></td>
                        <td className="accentNumCol">{format.formatCurrency(this.editModel.Diff.NewSalePrice, true)}</td>
                        <td className={"accentNumCol " + currPriceVarClass}>{format.formatCurrency(currPriceVar, true)}<span className={(currPriceVar > 0 ? "accentUp " + currPriceVarClass : currPriceVar < 0 ? "accentDown " + currPriceVarClass : undefined)} /></td>
                        <td className="accentNumCol">{userAllowCost ? format.formatPercentage(this.editModel.Diff.NewMargin, true) : ""}</td>
                        <td className={"accentNumCol " + currPriceMarginVarClass}>{userAllowCost ? format.formatPercentage(currPriceMarginVar, true) : ""}<span className={(currPriceMarginVar > 0 ? "accentUp " + currPriceMarginVarClass : currPriceMarginVar < 0 ? "accentDown " + currPriceMarginVarClass : undefined)} /></td>
                    </tr>
                </tbody>
            </Table>
            {!this.keepPriceMode ? null :
                <div className="mt-2">
                    <a href="#" onClick={e => { e.preventDefault(); this.onToggleJobPriceActions(false); }}>{t(`${keepPriceStrings}.keepPriceUseLineDecisions`)}</a>
                </div>}
        </div>;
    }

    getReviewContent() {

        return <div style={{width:"100%", maxWidth:"1500px"}}>
            {this.state.priceLoading ? <div className="text-center"><label>{t("application_strings.application.dialogs.finishEditJob.updatingPrice")}</label><AccentSpinner /></div>                    
                    : <JobDiffCtrl diff={this.editModel.Diff} quoted={this.editModel.QuoteInfo} userModel={this.userModel} />}
            </div>;

    }

    getWarningsContent() {
        return <div style={{ width: "100%", maxWidth: "1500px" }}>
            <div className="alert alert-info" role="alert">{t("application_strings.application.dialogs.finishEditJob.affectsInfo")}</div>
            {this.getConflictTable()}
        </div>;
    }


    render() {

        


        

        const allowNext = !this.state.priceLoading && (
            (this.state.step === 0 && this.state.allowMoveToReview) || (this.state.step === 1 && this.state.allowMoveToWarnings) || (this.state.step === 2)
        );
        const allowPrevious = (this.state.step === 1 && allowNext) || (this.state.step === 2 && allowNext);



        const steps = [
            {
                label: t("application_strings.application.dialogs.finishEditJob.pricingTitle"),
                disabled: (this.state.step > 0 && !allowPrevious)
            },
            {
                label: t("application_strings.application.dialogs.finishEditJob.reviewTitle"),
                disabled: this.state.priceLoading || !this.state.allowMoveToReview
            },
            {
                label: t("application_strings.application.dialogs.finishEditJob.affectsTitle"),
                disabled: this.state.priceLoading || !this.state.allowMoveToWarnings
            }
        ];


        const content = (this.state.step === 0)
            ? this.getPricingContent()
            : (this.state.step === 1)
                ? this.getReviewContent()
                :this.getWarningsContent();

        const changesSummaryBtn = this.state.step === 1
            ? <AccentButton
                key="changesSummary"
                tagName="changesSummaryBtn"
                onClick={() => {
                    const u = getUser();
                    showJobChangesSummaryReport({ jobId: this.jobID, primaryUserInitials: u?.Initials });
                }}
            >
                Changes Summary
            </AccentButton>
            : null;

        return (
            <AccentDialog
                fullscreen
                headerContent={t("application_strings.application.dialogs.finishEditJob.title") }
                onClose={this.props.onClose}
                actionsContent={[
                    <AccentButton key="prev" tagName="prevBtn" disabled={!allowPrevious} onClick={e => this.onStepChanged({ ...e, value: this.state.step - 1 })}>{t("application_strings.application.buttons.previous")}</AccentButton>,
                    changesSummaryBtn,
                    <AccentButton key="next" tagName="nextBtn" disabled={!allowNext} onClick={e => this.onStepChanged({ ...e, value: this.state.step + 1 })}>{t(`application_strings.application.buttons.${this.state.step === 2 ? "finish" : "next" }`)}</AccentButton>
                ].filter(Boolean)}
            >
                
                <Stepper value={this.state.step} onChange={this.onStepChanged} items={steps} />
                <hr />
                <div className="d-flex justify-content-around">
                    {content}
                </div>
            </AccentDialog>
        );
    }

}


